import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditorSkeleton } from '@factorialco/f0-react/dist/experimental'

interface MeetingSkeletonProps {
  withPadding?: boolean
}

export const MeetingSkeleton = ({ withPadding = false }: MeetingSkeletonProps) => {
  return (
    <Box height="full" flexDirection="row" style={{ overflow: 'hidden' }}>
      <Box height="full" flexGrow overflowX="hidden">
        <NotesTextEditorSkeleton withPadding={withPadding} withHeader withTitle />
      </Box>
    </Box>
  )
}
